export const usePublicSeasonSelection = () => {
    const resetSeasonSports = useState<number[]>('public-season-reset-sports', () => [])
    const selectedSeasonPerSport = useState<Record<number, number>>('public-season-selection', () => {
        if (!import.meta.client) return {}

        try {
            const stored: unknown = JSON.parse(localStorage.getItem('selectedSeasonPerSport') ?? '{}')

            if (!stored || typeof stored !== 'object' || Array.isArray(stored)) return {}

            return Object.fromEntries(Object.entries(stored).filter(([key, value]) => /^\d+$/.test(key) && Number.isSafeInteger(value) && Number(value) > 0))
        } catch {
            return {}
        }
    })

    function saveSelectedSeasonsToStorage() {
        try {
            localStorage.setItem('selectedSeasonPerSport', JSON.stringify(selectedSeasonPerSport.value))
        } catch { /* Die Saisonwahl bleibt auch ohne verfügbaren Browserspeicher nutzbar. */ }
    }

    function setSelectedSeasonId(sportId: number | undefined, seasonId: number) {
        if (!sportId) return

        selectedSeasonPerSport.value = {...selectedSeasonPerSport.value, [sportId]: seasonId}
        saveSelectedSeasonsToStorage()
    }

    return {resetSeasonSports, selectedSeasonPerSport, setSelectedSeasonId, saveSelectedSeasonsToStorage}
}
